import { fetchFromOldApi } from '~/services/Http';

import { RehireForm } from '../hooks/useRehireEmpForm';

export const rehireEmployee = async (
  empId: number,
  data: RehireForm,
  onAfterSubmit: (success: boolean) => void,
) => {
  const api = `/json/employee/${empId}/rehire`;
  return await fetchFromOldApi(api, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then((r) => r.json())
    .then(() => {
      onAfterSubmit(true);
    })
    .catch((e) => {
      onAfterSubmit(false);
      console.log('error', e);
    });
};
